"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function Checkbox({ value, onChange, onBlur, id, isReadOnly }) {
    const opts = {};
    if (isReadOnly)
        opts.disabled = 'disabled';
    return (react_1.default.createElement("input", { ...opts, type: "checkbox", checked: value === '100', id: id, onChange: onChange, onBlur: onBlur }));
}
exports.default = Checkbox;
//# sourceMappingURL=Checkbox.js.map